
import moment from "moment";

export default {
  name: "RelatorioDREGerencialTable",
  props: {
    linhas: {
      type: Array,
      required: true,
    },
    periods: {
      type: Array,
      required: true,
    },
  },
  methods: {
    isCurrentPeriod(period) {
      const now = moment();
      // Mensal: MM/YYYY
      if (/^\d{2}\/\d{4}$/.test(period)) {
        return period === now.format("MM/YYYY");
      }
      // Trimestral: T1-T4/YYYY
      if (/^T\d\/\d{4}$/.test(period)) {
        const [q, year] = period.split("/");
        const quarter = parseInt(q.replace("T", ""));
        return parseInt(year) === now.year() && now.quarter() === quarter;
      }
      // Semestral: S1-S2/YYYY
      if (/^S\d\/\d{4}$/.test(period)) {
        const [s, year] = period.split("/");
        const semester = parseInt(s.replace("S", ""));
        const currentSemester = now.month() < 6 ? 1 : 2;
        return parseInt(year) === now.year() && currentSemester === semester;
      }
      // Anual: YYYY
      if (/^\d{4}$/.test(period)) {
        return parseInt(period) === now.year();
      }
      return false;
    },
    formatPeriodHeader(period) {
      // Mensal: MM/YYYY
      if (/^\d{2}\/\d{4}$/.test(period)) {
        const [month, year] = period.split("/");
        const m = moment(`${year}-${month}-01`).locale("pt-BR");
        const abbr = m.format("MMM");
        const capitalized = abbr.charAt(0).toUpperCase() + abbr.slice(1).replace(".", "");
        return `${capitalized} de ${year}`;
      }
      // Trimestral: T1/2026
      if (/^T\d\/\d{4}$/.test(period)) {
        const [q, year] = period.split("/");
        return `${q}° Trim. ${year}`;
      }
      // Semestral: S1/2026
      if (/^S\d\/\d{4}$/.test(period)) {
        const [s, year] = period.split("/");
        return `${s.replace("S", "")}° Sem. ${year}`;
      }
      // Anual: 2026
      if (/^\d{4}$/.test(period)) {
        return period;
      }
      return period;
    },
    getBalance(balances, period) {
      const found = (balances || []).find((b) => b.period === period);
      return found ? found.balance : 0;
    },
    planoTotal(balances) {
      return (balances || []).reduce((sum, b) => sum + (b.balance || 0), 0);
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }).format(value || 0);
    },
    valueClass(value) {
      if (value > 0) return "text-success";
      if (value < 0) return "text-danger";
      return "";
    },
  },
};
